import { Collection } from 'modules/core/lib/mobx-rest'

import ManualIncidence from 'modules/bookkeepers/store/models/ManualIncidence'

class ManualIncidences extends Collection<ManualIncidence> {
  get cacheKey(): string {
    return 'manualIncidences'
  }

  model() {
    return ManualIncidence
  }
}

export default ManualIncidences
